<template>
    <v-container fluid>
        <v-layout row wrap align-center>
            <v-btn
                color="primary"
                :to="'/project/' + this.currentProjectId + '/dashboard'"
                class="ml-0"
            >
                {{$t('backToDashboard')}}
            </v-btn>
            <span class="text-xs-left display-1 mb-4 pt-4">
                {{dataApiDetail.api_name}}
            </span>
            <v-spacer></v-spacer>
            <div>
                <v-select
                    :label="$t('interval') | capitalize"
                    v-model="chartInterval"
                    :items="chartIntervalList"
                ></v-select>
            </div>
            <TimeRangePicker v-model="filterDateRange" ref="TimeRangePicker"></TimeRangePicker>
        </v-layout>
        <div>{{$t('enabledFrom')}}: {{dataApiDetail.created_at | formatDateTime}}</div>
        <table class="detail-table">
            <tr>
                <td>{{$t('freeRemain') | capitalize}}</td>
                <td>:</td>
                <td>{{getFreeRemaining()}} {{unit}}</td>
                <td>{{$t('requests') | capitalize}}</td>
                <td>:</td>
                <td>{{dataApiDetail.requests}}</td>
            </tr>
            <tr>
                <td>{{$t('paidRemain') | capitalize}}</td>
                <td>:</td>
                <td>{{getPaidRemaining()}} {{unit}}</td>
                <td>{{$t('errorRequests') | capitalize}}</td>
                <td>:</td>
                <td>{{dataApiDetail.error_requests}}</td>
            </tr>
        </table>
        <v-layout row wrap class="mt-3">
            <v-flex xl4 lg4 md12 sm12 xs12 text-xs-left>
                <p class="pa-2 title">{{$t('traffic') | capitalizeAll}}</p>
                <UsageChart
                    :data="dataAnalytics"
                    :time-range="chartTimeRange"
                    :interval="chartInterval"
                ></UsageChart>
            </v-flex>
            <v-flex xl4 lg4 md12 sm12 xs12 text-xs-left>
                <p class="pa-2 title">{{$t('errors') | capitalizeAll}}</p>
                <UsageChart
                    :data="dataError"
                    :time-range="chartTimeRange"
                    :interval="chartInterval"
                ></UsageChart>
            </v-flex>
            <v-flex xl4 lg4 md12 sm12 xs12 text-xs-left>
                <p class="pa-2 title">{{$t('medianLatency') | capitalizeAll}} (ms)</p>
                <LatencyChart
                    :data="medianLatency"
                    :time-range="chartTimeRange"
                    :interval="chartInterval"
                ></LatencyChart>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
import UsageChart from '@/views/Dashboard/UsageChart'
import LatencyChart from '@/views/Dashboard/LatencyChart'
import TimeRangePicker from '@/modules/fptai/components/TimeRangePicker'
import DashboardService from '@/services/dashboard.service'
import ApiService from '@/services/apis.service'
import DashboardMixin from '@/views/Dashboard/DashboardMixin'

export default {
    name: 'Dashboard',
    components: {
        UsageChart,
        LatencyChart,
        TimeRangePicker
    },
    mixins: [DashboardMixin],
    data () {
        return {
            dataAnalytics: [],
            dataError: [],
            dataApiUsage: [],
            dataApiDetail: {
                usage: {
                    paid: { remaining: 0 },
                    free: { remaining: 0 }
                },
                api_name: '',
                requests: 0,
                error_requests: 0
            },
            interval: null,
            medianLatency: [],
            apiCode: '',
            chartTimeRange: null,
            CONST: this.$const
        }
    },
    computed: {
        unit () {
            return this.$t(ApiService.getApiUnit(this.apiCode))
        }
    },
    mounted () {
        this.getDataDashboard()
        this.interval = setInterval(this.getDataDashboard, 10000)
    },
    destroyed () {
        clearInterval(this.interval)
    },
    methods: {
        getDataDashboard () {
            this.chartTimeRange = this.$refs.TimeRangePicker.getTimestamp()
            DashboardService.getApiAnalytics(
                this.$route.params.project_id,
                this.$route.params.api,
                this.chartTimeRange,
                this.chartInterval
            ).then(
                dataRes => {
                    if (dataRes.status) {
                        this.apiCode = dataRes.data.api_code
                        this.dataAnalytics = dataRes.data.data
                        this.dataError = dataRes.data.data_error
                        this.dataApiUsage = dataRes.data.data_table
                        this.dataApiDetail = dataRes.data.data_table[0]
                        this.medianLatency = dataRes.data.data_median_latency
                    } else {
                        this.dataAnalytics = []
                        this.dataError = []
                        this.dataApiUsage = []
                        this.medianLatency = []
                    }
                }
            )
        },
        getFreeRemaining () {
            if (this.dataApiDetail.usage.free && this.currentProjectType === this.$const.projectType.PREPAID) {
                return this.$filters.formatNumber(this.dataApiDetail.usage.free.remaining)
            }
            return 0
        },
        getPaidRemaining () {
            if (this.dataApiDetail.usage.paid) {
                let remaining = this.dataApiDetail.usage.paid.remaining
                try {
                    return this.$filters.formatNumber(parseInt(remaining))
                } catch (e) {
                    return remaining
                }
            }
            return 0
        }
    }
}
</script>
<style scoped lang="scss">
    .detail-table tr {
        td:first-child {
            font-weight: bold;
        }

        td:nth-child(2) {
            font-weight: bold;
            padding-right: 5px;
        }

        td:nth-child(4) {
            font-weight: bold;
            padding-left: 20px;
        }

        td:nth-child(5) {
            font-weight: bold;
            padding-right: 5px;
        }
    }
</style>
